export function accordionInit(selector) {
  var i;
  var acc = document.getElementsByClassName(selector + "__trigger");

  if (acc) {
    for (i = 0; i < acc.length; i++) {
      acc[i].addEventListener("click", accordion);
      var close = acc[i].nextElementSibling.querySelector(".accordion__close");

      if (close) {
        close.addEventListener("click", accordionClose);
      }
    }
  }
}

export function accordionDestroy(selector) {
  var i;
  var acc = document.getElementsByClassName(selector + "__trigger");

  if (acc) {
    for (i = 0; i < acc.length; i++) {
      acc[i].removeEventListener("click", accordion);
      acc[i].classList.remove("active");
      var panel = acc[i].nextElementSibling;
      panel.style.maxHeight = null;
      var close = acc[i].nextElementSibling.querySelector(".accordion__close");

      if (close) {
        close.removeEventListener("click", accordionClose);
      }
    }
  }
}

function accordionClose() {
  this.parentNode.style.maxHeight = null;
}

function accordion() {
  this.classList.toggle("active");
  var panel = this.nextElementSibling;

  if (panel.style.maxHeight) {
    panel.style.maxHeight = null;
  } else {
    panel.style.maxHeight = panel.scrollHeight + "px"; // Для фильтров каталога

    if (panel.classList.contains("show-more")) {
      var a = document.querySelector(".show-more__container");

      if (a.style.maxHeight) {
        panel.style.maxHeight =
          +panel.style.maxHeight.slice(0, -2) +
          +a.style.maxHeight.slice(0, -2) +
          "px";
      }
    }
  }
}

// TODO: подобного кода не должно быть здесь, в компоненте для общего пользования.
// accordionInit("accordion");
// Для фильтров каталога
// if (document.querySelector(".categories__filter")) {
//   document.addEventListener("click", function (e) {
//     var target = e.target;
//     var accordionHideOnBlur = document.querySelector(
//       ".accordion_hide_on_blur "
//     );
//     var sortingContainer = document.querySelector(".categories__sorting");

//     if (
//       !target.closest(".accordion_hide_on_blur_container") &&
//       accordionHideOnBlur.classList.contains("active")
//     ) {
//       accordionHideOnBlur.classList.remove("active");
//       sortingContainer.style.maxHeight = null;
//     }
//   });
// }
